// Mock data for EasyWorks clone

export const navLinks = [
  { label: 'Startup and Compliance', href: '/startup-and-compliance' },
  { label: 'VPOB APOB', href: '/vpob-apob' },
  { label: 'GST Advisory', href: '/gst-advisory' },
  { label: 'E-Commerce Accounting', href: '/ecommerce-accounting' },
  { label: 'Blog', href: '/blog' },
  { label: 'Contact Us', href: '/contact-us' },
];

export const heroTags = [
  'Proprietorship',
  'Amazon E-Commerce',
  'LLP Compliance',
  'APoB & VPoB',
  'Company Registration',
  'GST Registration',
  'Private Limited Company',
];

export const serviceTypes = [
  'VPOB & APOB',
  'GST Advisory',
  'Startup Compliance',
  'Fixed Desk',
  'Company Registration',
];

export const ecommercePartners = [
  { name: 'Amazon', url: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg' },
  { name: 'Flipkart', url: 'https://upload.wikimedia.org/wikipedia/commons/8/8c/Flipkart_logo.svg' },
  { name: 'Meesho', url: 'https://upload.wikimedia.org/wikipedia/commons/4/45/Meesho_Logo_New.png' },
  { name: 'Myntra', url: 'https://upload.wikimedia.org/wikipedia/commons/f/fb/Myntra_logo.png' },
  { name: 'JioMart', url: 'https://upload.wikimedia.org/wikipedia/commons/9/9e/JioMart_logo.svg' },
];

export const customerLogos = [
  { name: 'Cocoblu' },
  { name: 'A3M' },
  { name: 'FORCAS' },
  { name: 'Linkers' },
  { name: 'GMN Healthcare' },
];

export const states = [
  'Assam','Haryana','Karnataka','Delhi','Uttar Pradesh','Madhya Pradesh',
  'Gujarat','Telangana','Maharashtra','Punjab','Rajasthan','Tamil Nadu',
  'West Bengal','Bihar',
];

export const stats = [
  { number: '28,000+', label: 'Sellers Served', icon: 'UserCheck' },
  { number: '96%', label: 'GST Approval Rate', icon: 'ShieldCheck' },
  { number: '30+', label: 'Locations Covered', icon: 'MapPin' },
  { number: '24hr', label: 'Response Time', icon: 'Clock' },
];

export const officeImages = [
  'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80',
  'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800&q=80',
  'https://images.unsplash.com/photo-1604328698692-f76ea9498e76?w=800&q=80',
  'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=800&q=80',
  'https://images.unsplash.com/photo-1568992687947-868a62a9f521?w=800&q=80',
  'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&q=80',
  'https://images.unsplash.com/photo-1568992688065-536aad8a12f6?w=800&q=80',
  'https://images.unsplash.com/photo-1497215728101-856f4ea42174?w=800&q=80',
  'https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?w=800&q=80',
  'https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?w=800&q=80',
  'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800&q=80',
  'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&q=80',
];

export const processSteps = [
  {
    step: '01',
    title: 'Free Consultation',
    desc: 'Get in Touch with our Experts.',
  },
  {
    step: '02',
    title: 'Share Documents',
    desc: 'Send all your legal documents required',
  },
  {
    step: '03',
    title: 'Document Verification',
    desc: 'Our team will complete the KYC',
  },
  {
    step: '04',
    title: 'Order Complete',
    desc: 'Yes, Its Done! just 4 Simple steps',
  },
];

export const testimonials = [
  {
    quote: "I can't say enough good things about Easyworks. Their virtual office services have completely transformed the way I run my business.",
    name: 'Albert Coalark',
    role: 'CEO of Walmart',
    avatar: 'https://i.pravatar.cc/120?img=12',
  },
  {
    quote: 'Easy Works has been an invaluable partner for Mitchell USA. Their exceptional virtual office and accounting services have streamlined our processes and allowed us to focus on our core business.',
    name: 'Prajwal Cerejo',
    role: 'MIS & Accounts Executive, Mitchell USA Pvt. Ltd.',
    avatar: 'https://i.pravatar.cc/120?img=33',
  },
  {
    quote: 'As a freelancer, I needed a professional image to attract high-paying clients. Easyworks provided me with a prestigious business address and personalized phone answering services that have elevated my brand.',
    name: 'Riya Sharma',
    role: 'Independent Consultant',
    avatar: 'https://i.pravatar.cc/120?img=47',
  },
  {
    quote: 'As a startup founder, I needed a flexible and cost-effective solution for establishing my business presence. Thanks to Easyworks, I now have a professional address and dedicated phone answering services without the overhead of a traditional office.',
    name: 'Karan Mehta',
    role: 'Founder, BlueLeaf Ventures',
    avatar: 'https://i.pravatar.cc/120?img=15',
  },
  {
    quote: "I've been using Easyworks for several years now, and I couldn't be happier with their services. Their virtual office packages are affordable and customizable, allowing me to tailor my plan to fit my specific needs.",
    name: 'Anita Verma',
    role: 'Director, Verma Trading Co.',
    avatar: 'https://i.pravatar.cc/120?img=23',
  },
  {
    quote: 'Top-notch GST advisory and quick turnaround for VPOB across multiple states. Highly recommend their team for any e-commerce seller.',
    name: 'Suresh Iyer',
    role: 'Operations Head, Cocoblu',
    avatar: 'https://i.pravatar.cc/120?img=51',
  },
];

export const faqs = [
  { q: 'What is a virtual office?', a: 'A virtual office provides businesses with a professional address, phone number, and mail handling without the need for a physical office space. It is perfect for startups and remote-first businesses that need a credible business presence.' },
  { q: 'What are the benefits of a virtual office?', a: 'A virtual office gives you a prestigious business address for registration, GST applications, mail handling, lower overheads and the flexibility to work from anywhere while maintaining a professional image.' },
  { q: 'Can I use the virtual office address for my business registration?', a: 'Yes, our virtual office addresses are fully compliant and can be used for business registration, GST registration, and all official correspondence.' },
  { q: 'What is a fixed desk?', a: 'A fixed desk is a dedicated workstation reserved exclusively for you in our partner offices. It includes a permanent name board, storage, and mail handling support.' },
  { q: 'How does mail handling work?', a: 'Our team receives, scans, and forwards your mail according to your preferences. You can also opt for pick-up at our office locations.' },
  { q: 'How can I get started with Easy Works?', a: 'Simply fill out the free consultation form on the homepage or call us. Our experts will guide you through the process within 24 hours.' },
  { q: 'What accounting services do you offer?', a: 'We offer bookkeeping, tax filing, GST returns, payroll, financial reporting and CFO advisory services tailored for small and medium businesses.' },
  { q: 'What compliance services do you offer?', a: 'From company incorporation, ROC filings, GST compliance, TDS filings to annual returns - we cover the entire spectrum of statutory compliances.' },
  { q: 'How can your accounting and compliance services benefit my business?', a: 'You save time, avoid penalties and get expert guidance on tax savings, allowing you to focus on growing your business.' },
  { q: 'What GST advisory services do you offer?', a: 'GST registration, returns filing, revocations, refunds, appeals, show cause notice handling and departmental case representation.' },
  { q: 'How can GST advisory services benefit my business?', a: 'Stay 100% compliant, claim eligible refunds, respond to notices in time and avoid heavy penalties with the help of seasoned GST experts.' },
  { q: 'What documents are required for GST registration?', a: 'PAN card, Aadhaar, business address proof, bank details, photographs and business constitution proof are the primary documents required.' },
  { q: 'How often do I need to file GST returns?', a: 'Most businesses file monthly (GSTR-1, GSTR-3B) and an annual return (GSTR-9). Composition dealers file quarterly returns.' },
  { q: 'Can you assist with GST audits?', a: 'Absolutely. Our team helps with departmental audits, reconciliation, and representing your case before officers.' },
  { q: 'What are the major states in which we provide virtual offices?', a: 'We provide VPOB & APOB services across 30+ locations including Delhi, Haryana, Karnataka, Maharashtra, Tamil Nadu, Gujarat, Telangana and more.' },
  { q: 'Do I receive a dedicated phone number?', a: 'Yes, with our dedicated desk plan you get a unique business phone number and call handling support.' },
  { q: 'Who can use a Virtual Office?', a: 'Freelancers, startups, e-commerce sellers, growing SMEs, and enterprises needing presence in multiple states can use a virtual office.' },
  { q: 'Can a GST number be applied to a virtual office address?', a: 'Yes, our virtual office addresses come with all required documents (Agreement, NOC, Utility Bill) accepted by GST authorities.' },
];

export const pricingPlans = [
  {
    name: 'Virtual Office',
    price: '799',
    benefits: [
      'Agreement and NOC',
      'Utility Bills',
      'Registered by CA/ Lawyer',
      'Temporary Signage',
      'Lifetime Support',
      'Renewal Reminder and Support',
      'Medium Compliance Level',
    ],
    highlight: false,
  },
  {
    name: 'Shared Desk',
    price: '2000',
    benefits: [
      'Agreement and NOC',
      'Utility Bills',
      'Registered by CA/ Lawyer',
      'Standard Permanent Namboard Outside Premises',
      'Lifetime Support',
      'Renewal Reminder and Support',
      'High Compliance Level',
      'Flexible Payment Options',
      'Satisfaction Guarantee',
      '24/7 Customer Support',
    ],
    highlight: true,
  },
  {
    name: 'Dedicated Desk',
    price: '3000',
    benefits: [
      'Agreement and NOC',
      'Utility Bills',
      'Registered by CA/ Lawyer',
      'Standard Permanent Namboard Outside Premises',
      'Lifetime Support',
      'Renewal Reminder and Support',
      'Highest Compliance Level',
      'Unique Desk Number',
      'Mail Handling Support',
      'Storage Provision for books',
      'Standard Permanent Name Board on Desk',
      'Authorised Representative',
    ],
    highlight: false,
  },
];

export const footerLinks = {
  quick: [
    { label: 'Startup and Compliance', href: '/startup-and-compliance' },
    { label: 'VPOB APOB', href: '/vpob-apob' },
    { label: 'GST Advisory', href: '/gst-advisory' },
    { label: 'E-Commerce Accounting', href: '/ecommerce-accounting' },
    { label: 'Contact Us', href: '/contact-us' },
  ],
  gst: [
    { label: 'GST Revocation', href: '/gst-advisory?service=GST%20Revocation' },
    { label: 'GST Refund', href: '/gst-advisory?service=GST%20Refund' },
    { label: 'GST Appeal', href: '/gst-advisory?service=GST%20Appeal' },
    { label: 'Show Cause Notice', href: '/gst-advisory?service=Show%20Cause%20Notice' },
    { label: 'Summons Or Departmental Cases', href: '/gst-advisory?service=Summons%20Or%20Departmental%20Cases' },
  ],
  states: [
    { label: 'Delhi', href: '/virtual-office-in/delhi' },
    { label: 'Maharashtra', href: '/virtual-office-in/maharashtra' },
    { label: 'Karnataka', href: '/virtual-office-in/karnataka' },
    { label: 'Haryana', href: '/virtual-office-in/haryana' },
    { label: 'Tamil Nadu', href: '/virtual-office-in/tamil-nadu' },
    { label: 'View all 30+ locations', href: '/vpob-apob' },
  ],
  legal: [
    { label: 'Terms of Service', href: '/terms-of-service' },
    { label: 'Refund Policy', href: '/refund-policy' },
    { label: 'Privacy Policy', href: '/privacy-policy' },
  ],
};
